import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import node from '../assets/node.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';

import about01 from '../assets/about01.png';
import about02 from '../assets/about02.png';
import about03 from '../assets/about03.png';
import about04 from '../assets/about04.png';

import profile from '../assets/profile.png';
import circle from '../assets/circle.svg';
import logodark from '../assets/logodark.png';
import logowhite from '../assets/logowhite.png';


export default {
  email,
  mobile,
  api,
  css,
  figma,
  git,
  graphql,
  html,
  javascript,
  node,
  react,
  redux,
  sass,
  about01,
  about02,
  about03,
  about04,
  profile,
  circle,
  logodark,
  logowhite,
};